
import { signOut } from './authOperations';

export async function performLogout() {
  await signOut();
}
